<template>
  <div class="flex animate-pulse flex-col gap-2 p-2">
    <!-- Top line -->
    <div class="flex items-center justify-between">
      <div class="h-4 w-40 rounded bg-steel-200" />
      <div class="h-5 w-5 rounded-full bg-steel-100" />
    </div>

    <!-- Expanded section -->
    <div
      v-if="isSelected"
      class="mt-3 flex flex-col gap-2 px-2 pb-4 pt-2 text-left text-xs"
    >
      <div class="flex flex-col gap-1">
        <div class="h-3 w-20 rounded bg-steel-100" />
        <div class="h-4 w-full rounded bg-steel-200" />
      </div>
      <div class="h-3 w-16 rounded bg-steel-100" />
    </div>
  </div>
</template>

<script setup>
defineProps({
  isSelected: Boolean,
});
</script>
